var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Icon } from '@doordash/design-language';
import styled from 'styled-components';
import ListCell from '@doordash/component-list-cell';
var CellContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 0;\n"], ["\n  margin-top: 0;\n"])));
var Cell = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(ListCell, __assign({ size: ListCell.Sizes.Small, titleMaxLines: 2, isToggleable: false, accessibilityLabel: props.title, insetSize: ListCell.InsetSizes.XSmall }, props)));
};
var ProductOptionsBenefitListCell = function (_a) {
    var benefitStrings = _a.benefitStrings, iconType = _a.iconType;
    return (React.createElement(CellContainer, { role: "list" }, benefitStrings.map(function (benefitName, index) {
        var isLastCell = index === benefitStrings.length - 1;
        return (React.createElement(Cell, { key: benefitName + "-" + index, title: benefitName, isSeparatorVisible: !isLastCell, iconStart: {
                type: iconType,
                color: iconType === Icon.Types.Check
                    ? Icon.Colors.SystemGreen60
                    : Icon.Colors.SystemGrey30,
            } }));
    })));
};
export default ProductOptionsBenefitListCell;
var templateObject_1;
